import CrossIcon from '@shared/assets/icons/cross.svg';
import TimerIcon from '@shared/assets/icons/timer.svg';
import { MBText } from '@shared/components/MBText';
import { View } from '@shared/components/View';
import { MBIcon } from '@shared/components/image';
import { MBTouchableIcon, MBTouchableOpacity } from '@shared/components/touchable';
import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { Styles } from './styles';

export interface MBUrgentBannerProps {
  count: number | undefined;
  onRemoveSendAsUrgent: () => void;
  onPress?: () => void;
}

export function MBUrgentBannerComponent({
  count,
  onPress,
  onRemoveSendAsUrgent,
}: MBUrgentBannerProps) {
  return (
    <MBTouchableOpacity onPress={onPress} style={Styles.urgentBanner}>
      <View row centerVertically padding={1}>
        <MBIcon noPadding size="small" source={TimerIcon} />
        <View flex paddingHorizontal={1}>
          {/* TODO(fant): replace this once we've figured
                    out how to calculate # mentioned users */}
          {(() => {
            if (count !== undefined) {
              return (
                <MBText color={Colors.v2.purple}>
                  <MBText>{i18n('chat.urgent.banner.start', { count })}</MBText>
                  <MBText bold>{i18n('chat.urgent.banner.count', { count })}</MBText>
                  <MBText>{i18n('chat.urgent.banner.end')}</MBText>
                </MBText>
              );
            }

            return (
              <MBText>
                Send as urgent and contact everyone in this chat by text message (SMS)?
              </MBText>
            );
          })()}
        </View>
        <MBTouchableIcon
          size="small"
          source={CrossIcon}
          color={Colors.gray.normal}
          onPress={onRemoveSendAsUrgent}
        />
      </View>
    </MBTouchableOpacity>
  );
}
